export default "__VITE_ASSET__dbd28b5c__"